/* eslint-disable */
import axios from "axios";
import Vue from "vue";
import { EventBus } from "../../events/eventBus";
import AcceptInvitation from "../../components/AcceptInvitation";

export default {
  namespaced: true,
  state: {
    user: {},
    token: null,
    session: null,
    sockets: [],
    isLoading: true,
    isMobile: false,
    isMobileDevice: false,
    showAllConversations: null,
    viewport: {},
    userTheme: "light",
    isDarkMode: false,
    isVoiceSDKLoaded: false,
    isEmbedSDKLoaded: false,
    userLanguage: "en",
    colors: [
      "navy",
      "purple",
      "cyan",
      "grey",
      "maroon",
      "blue",
      "skyblue",
      "slateblue",
    ],
    pendingInvitations: [],
    soundSelectorSetting: {
      videoJoinedNotificationSound: {
        label: "Video Participant Joined",
        enabled: false,
        value: "doorbell-1",
      },
      videoLeftNotificationSound: {
        label: "Video Participant Left",
        enabled: false,
        value: "door-9-close",
      },
      messageNotificationSound: {
        label: "Inbound Message Notification",
        enabled: false,
        value: "notification",
      },
      voiceNotificationSound: {
        label: "New Inbound Voice Conversation",
        enabled: false,
        value: "sos",
      },
      textNotificationSound: {
        label: "New Inbound SMS Conversation",
        enabled: false,
        value: "sos",
      },
      textTo911NotificationSound: {
        label: "New Inbound Text-to-911 Conversation",
        enabled: false,
        value: "sos"
      },
    },
    volume: 0.75,
    userSidebarOpened: true,
    userRightSidebarOpened: true,
    userModules: [],
    userCurrentModule: null,
    userCreateNewPoppver: true,
    userCallTakerModeEnabled: false,
    userCallTakerPosition: null,
    userDashboardView: false,
    userTemplates: [],
  },
  mutations: {
    setCurrentUser: (state, user) => {
      state.user = user;
      state.isLoading = false;
    },
    setUserSession: (state, session) => (state.session = session),
    setUserJwt: (state, token) => (state.token = token),
    updateUserSockets: (state, socketId) =>
      (state.sockets = [...state.sockets, socketId]),
    setIsMobile: (state, value) => (state.isMobile = value),
    setViewport: (state, value) => (state.viewport = { ...value }),
    setUserTheme: (state, value) => (state.userTheme = value),
    setIsDarkMode: (state, value) => (state.isDarkMode = value),
    setIsMobileDevice: (state, value) => (state.isMobileDevice = value),
    setShowAllConversations: (state, value) => {
      state.showAllConversations = value;
      Vue.prototype.$cookie.set("x-pref-showAll", value);
    },
    setPendingInvitations: (state, invitations) => {
      state.pendingInvitations = invitations;
    },
    setIsVoiceSDKLoaded: (state, value) => { state.isVoiceSDKLoaded = value; },
    updateSoundSelectorSetting: (state, setting) => {
      state.soundSelectorSetting = { ...state.soundSelectorSetting, ...setting };
    },
    setVolume: (state, value) => {
      state.volume = value;
    },
    setIsEmbedSDKLoaded: (state, value) => {
      state.isEmbedSDKLoaded = value;
    },
    setUserSidebarOpened(state, value) {
      state.userSidebarOpened = value;
    },
    setUserRightSidebarOpened(state, value) {
      state.userRightSidebarOpened = value;
    },
    setUserCreateNewPoppver(state, value) {
      state.userCreateNewPoppver = value;
    },
    setUserCallTakerModeEnabled(state, value) {
      state.userCallTakerModeEnabled = value;
    },
    setUserCallTakerPosition(state, value) {
      state.userCallTakerPosition = value;
    },
    setUserDashboardView(state, value) {
      state.userDashboardView = value;
    },
    setUserTemplates(state, value) {
      state.userTemplates = [...value];
    }
  },
  getters: {
    currentUser: (state) => {
      if (state.user && JSON.stringify(state.user) !== "{}")
        return state.user;
      return null;
    },
    currentToken: (state) => state.token,
    currentSession: (state) => state.session,
    isMobile: (state) => state.isMobile,
    isMobileDevice: (state) => state.isMobileDevice,
    viewport: (state) => state.viewport,
    userTheme: (state) => state.userTheme,
    isDarkMode: (state) => state.isDarkMode,
    colors: (state) => state.colors,
    userLanguage: (state) => state.userLanguage,
    showAllConversations: (state) => {
      if (state.showAllConversations === null)
        return (
          Vue.prototype.$cookie.get("x-pref-showAll") !== null &&
          Vue.prototype.$cookie.get("x-pref-showAll") === "true"
        );

      return state.showAllConversations;
    },
    pendingInvitations: state => state.pendingInvitations,
    volume: state => state.volume,
    soundSelectorSetting: state => state.soundSelectorSetting,
    isVoiceSDKLoaded: state => state.isVoiceSDKLoaded,
    isEmbedSDKLoaded: (state) => state.isEmbedSDKLoaded,
    userSidebarOpened: state => state.userSidebarOpened,
    userRightSidebarOpened: state => state.userRightSidebarOpened,
    userCreateNewPoppver: state => state.userCreateNewPoppver,
    userCallTakerModeEnabled: state => state.userCallTakerModeEnabled,
    userCallTakerPosition: state => state.userCallTakerPosition ? state.userCallTakerPosition.position_id : null,
    userCallTakerPositionObj: state => state.userCallTakerPosition,
    userDashboardView: state => state.userDashboardView,
    userTemplates: state => state.userTemplates,
  },
  actions: {
    async fetchPendingInvitations({ commit }, data) {
      const { userEmail, token } = data;
      await axios
        .get(
          `${this._vm.$apihost}/invitations?fulfilled=false&userEmail=${userEmail}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          const invitations = res.data.data
          commit("setPendingInvitations", invitations);
          if (invitations.length > 0) {
            const $ = window.$;
            $("#id-modal-container").modal({
              backdrop: "static",
            });
            EventBus.$emit("open", {
              component: AcceptInvitation,
              title: "Invitation to Join Agency",
              closeOnClick: false,
              props: {},
            });
          }
        })
        .catch((err) => {
          commit("setPendingInvitations", []);
          console.log(err);
        });
    },
    updateCallTakerMode({ commit }, position) {
      if (!position) {
        commit("setUserCallTakerModeEnabled", false);
        commit("setUserCallTakerPosition", null);
      } else {
        commit("setUserCallTakerModeEnabled", true);
        commit("setUserCallTakerPosition", position);
      }
    }
  },
};
